import { useState } from "react";

import { useToken } from "../../hooks";
import type { AuthenticationTokenRequestData } from "../../schemas";

import { LoginTokenTemplate } from "./login-token.template";

export const LoginToken = () => {
	const { processToken } = useToken();
	const [processedTokenInvalid, setProcessedTokenInvalid] = useState<boolean>(false);

	const handleSubmit = async (data: AuthenticationTokenRequestData) => {
		setProcessedTokenInvalid(false);

		const [environmentOrToken, tokenOrEmpty] = data.token.split(";");

		const token = tokenOrEmpty ? tokenOrEmpty : environmentOrToken;

		const valid = await processToken(token.replace("BEARER ", "").replaceAll('"', ""));

		setProcessedTokenInvalid(valid === false);
	};

	return <LoginTokenTemplate onSubmit={handleSubmit} isError={processedTokenInvalid} />;
};
